import { Button } from '../../../../cdl/Button/Button';
import { Tooltip } from '../../../../cdl/Tooltip/Tooltip';
import { translate } from '../../../../common/helpers/translate.helper';
import { useEnrollmentTicketGenerate } from '../../hooks/useEnrollmentTicketGenerate';

const getMfaLoadingHtml = () => `<!doctype html>
<html>
    <head>
        <title>Loading...</title>
        <style>
            body {
                margin: 0;
                height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background: white;
            }
            
            img {
                width: 200px;
                margin-bottom: 20px;
            }
            
            .spinner {
                width: 80px;
                height: 4px;
                background: #e2eff580;
                border-radius: 2px;
                overflow: hidden;
            }
            
            .spinner::after {
                content: '';
                display: block;
                width: 100%;
                height: 100%;
                background: #193643;
                border-radius: 2px;
                animation: wobble 2.4s ease-in-out infinite;
                transform: translateX(-95%);
            }
            
            @keyframes wobble {
                0%, 100% { transform: translateX(-95%); }
                50% { transform: translateX(95%); }
            }
        </style>
    </head>
    <body>
        <img src="https://closelink-static.s3.eu-central-1.amazonaws.com/Wordmark.png" alt="Closelink">
        <div class="spinner"></div>
    </body>
</html>`;

interface AddAuthenticationMethodButtonProps {
    hasTotpMethod: boolean;
}

export const AddAuthenticationMethodButton = ({ hasTotpMethod }: AddAuthenticationMethodButtonProps) => {
    const enrollTicketMutation = useEnrollmentTicketGenerate();

    const onAddMethod = async () => {
        // Pre-open window immediately to avoid popup blocking
        const newWindow = window.open('', '_blank');

        if (!newWindow) {
            // Popup was blocked - fallback to same window
            const response = await enrollTicketMutation.mutateAsync();
            window.location.href = response.ticketUrl;
            return;
        }

        // Write MFA loading HTML to the new window
        newWindow.document.write(getMfaLoadingHtml());

        try {
            const response = await enrollTicketMutation.mutateAsync();
            // Navigate the pre-opened window to the MFA URL
            newWindow.location.href = response.ticketUrl;
        } catch (error) {
            // Close the window if API call failed
            newWindow.close();
            throw error;
        }
    };

    if (hasTotpMethod) {
        return null;
    }

    return (
        <Tooltip label={translate('mfa.authenticator.supportedApps')} side="bottom">
            <Button onClick={onAddMethod} isLoading={enrollTicketMutation.isPending}>
                {translate('mfa.authenticator.add')}
            </Button>
        </Tooltip>
    );
};
